export { default } from './useAcademyActivation';
